import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
export const ToggleFormComponent = ({ label, elementKey, onChange, selectedValue, defaultValue, isDisabled = false, }) => {
    const checkedValue = selectedValue ?? defaultValue;
    return (React.createElement("div", { className: styles.toggleContainer },
        React.createElement(Typography, { variant: "p" }, label),
        React.createElement(FormControl, { "data-testid": `test-id-${elementKey}`, noMarginBottom: true },
            React.createElement(Toggle, { checked: checkedValue, onChange: () => {
                    onChange(elementKey, !checkedValue);
                }, label: label, hideLabel: true, key: elementKey, disabled: isDisabled }))));
};
//# sourceMappingURL=toggle-form.component.js.map